import React from "react";
import { Layout } from "lucide-react";
import type { GeneratedSlides, ColorScheme } from "../types";
import { getSlideColor } from "../utils";

interface StructureSectionProps {
  generatedSlides: GeneratedSlides;
  colorScheme: ColorScheme;
}

export const StructureSection: React.FC<StructureSectionProps> = ({
  generatedSlides,
  colorScheme,
}) => {
  const primaryColor = getSlideColor(colorScheme);

  if (!generatedSlides?.structure?.length) return null;

  return (
    <div className="mb-8">
      <h4 className="font-bold mb-4 flex items-center gap-2 text-(--text-primary)">
        <Layout className="w-5 h-5" />
        Estrutura da Apresentação
      </h4>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {generatedSlides.structure.map((section, index) => (
          <div
            key={index}
            className="p-4 rounded-xl border border-(--border-color) bg-(--bg-accent)"
          >
            <h5 className="font-bold mb-2" style={{ color: primaryColor }}>
              {section.section}
            </h5>
            <div className="space-y-1">
              <div className="flex justify-between">
                <span className="text-sm text-(--text-tertiary)">Slides:</span>
                <span className="text-sm font-medium text-(--text-secondary)">
                  {section.slides}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-sm text-(--text-tertiary)">
                  Tempo estimado:
                </span>
                <span className="text-sm font-medium text-(--text-secondary)">
                  {section.time}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
